export default {
  root: {},
  textField: {
    width: '100%',
    background: '#fff',
  },
};
